<template>
    <div class="show-more-locked">
        <VJoyButton
            icon="lock"
            :label="label"
            :data-testid="testId"
            :href="href"
            rel="nofollow"
            variant="ghost"
            :size="size ?? 'medium'"
            @click="emits('click')"
        />
    </div>
</template>

<script setup lang="ts">
    import {VJoyButton, type TJoyButtonSizes} from '@maltjoy/core-vue';

    const props = defineProps<{
        label: string;
        testId: string;
        href?: string;
        size?: TJoyButtonSizes;
    }>();

    const emits = defineEmits<{
        (e: 'click'): void;
    }>();
</script>
<style lang="scss" scoped>
    .show-more-locked {
        display: flex;
        justify-content: center;

        :deep(.joy-button--slot) {
            white-space: wrap;
        }
    }
</style>
